import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setPoliteStatusMessage, setAssertiveStatusMessage } from 'shared/components/StatusMessages/actions';

const useFormErrorHandler = () => {
  const dispatch = useDispatch();

  // This assertive message announcement interrupts the user
  const setErrorMessage = useCallback((message) => dispatch(setAssertiveStatusMessage(message)), [dispatch]);

  // This polite message is announced when the user pauses
  const setErrorResolvedMessage = useCallback((message) => dispatch(setPoliteStatusMessage(message)), [dispatch]);

  return {
    setErrorMessage,
    setErrorResolvedMessage,
  };
};

export default useFormErrorHandler;
